module.exports = __webpack_public_path__ + "assets/img/pwd.a36129f4.png";